// --------------------------------------------------------------
// Created On: 2021-10-01
// Author: Zachary Thomas
//
// Last Modified: 2025-12-18
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import validateNickname from "../../../../utilities/validateNickname";
import styles from "./AssociatedAssetItem.module.scss";

// A single associated asset in a threshold management modal.
export default function AssociatedAssetItem(props: Props): Component {
  return (
    <Fragment>
      <div className={`${styles.body} px-4 py-2`}>
        {props.name} {validateNickname(props.nickname, props.name) ? `(${props.nickname})` : ""}{" "}
        {props.isMigrating ? <i className="fa fa-fw fa-exchange me-1" /> : null}
        {props.isRental ? <i className="fa fa-fw fa-calendar me-1" /> : null}
      </div>
    </Fragment>
  );
}

interface Props {
  assetId: number;
  name: string;
  nickname: string;
  isMigrating: boolean;
  isRental: boolean;
}
